import React from 'react';
import { Phone, Car } from 'lucide-react';
import { Button } from './ui/button';
import { companyInfo } from '../mockData';

const HeroSection = () => {
  const scrollToBooking = () => {
    const element = document.getElementById('booking-form');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1561555669-63fce64710cc"
          alt="Taxi Service"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/70 to-orange-900/60"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 py-20 mt-16">
        <div className="max-w-3xl">
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-4 leading-tight">
            Best Taxi & Cab Service in <span className="text-orange-500">Varanasi</span>
          </h1>
          <p className="text-xl md:text-2xl text-gray-200 mb-8">
            Safe • Affordable • 24×7 Service
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-wrap gap-4 mb-12">
            <Button
              onClick={scrollToBooking}
              className="bg-orange-600 hover:bg-orange-700 text-white text-lg px-8 py-6 rounded-lg shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all"
            >
              <Car className="w-5 h-5 mr-2" />
              Book Now
            </Button>
            <a href={`tel:${companyInfo.phone[0]}`}>
              <Button
                variant="outline"
                className="bg-white/10 backdrop-blur-sm text-white border-2 border-white hover:bg-white hover:text-orange-600 text-lg px-8 py-6 rounded-lg shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all"
              >
                <Phone className="w-5 h-5 mr-2" />
                Call Now
              </Button>
            </a>
          </div>

          {/* Trust Badges */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-white/10 backdrop-blur-md rounded-lg p-6 border border-white/20">
              <h3 className="text-3xl font-bold text-orange-500 mb-2">24/7</h3>
              <p className="text-white font-medium">Support</p>
            </div>
            <div className="bg-white/10 backdrop-blur-md rounded-lg p-6 border border-white/20">
              <h3 className="text-3xl font-bold text-orange-500 mb-2">100+</h3>
              <p className="text-white font-medium">Professional Drivers</p>
            </div>
            <div className="bg-white/10 backdrop-blur-md rounded-lg p-6 border border-white/20">
              <h3 className="text-3xl font-bold text-orange-500 mb-2">5000+</h3>
              <p className="text-white font-medium">Happy Customers</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
